<template>
  <v-container fluid>
    <!------------------------------------------ 表格数据搜索条件以及功能按键 ----------------------------------------->
    <v-row justify="center"
           class="mb-2"
           no-gutters>
      <v-col cols="11">
        <v-form>
          <!--------------------------    非展开搜索条件     -------------------------->
          <v-row>
            <v-col cols="2" class="py-0">
              <z-source-selector v-if="!wmsMngFlag"

                                 multiple
                  v-model="queryRequest.warehouseId"
                  hide-details="auto"
                  source="WarehouseSelector"
                  label="仓库"/>

              <z-source-selector v-else
                                 multiple
                                 v-model="queryRequest.warehouseId"
                                 hide-details="auto"
                                 source="WareHouseWmsManagerSelector"
                                 label="仓库"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field
                  @keydown.enter="handleQuery"
                  clearable
                  v-model="queryRequest.storageLocation"
                  label="库位"
                  hide-details="auto"
                  prepend-inner-icon="search"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field
                  @keydown.enter="handleQuery"
                  clearable
                  v-model="queryRequest.materielProdNo"
                  label="物料产品编码"
                  hide-details="auto"
                  prepend-inner-icon="search"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field
                  @keydown.enter="handleQuery"
                  clearable
                  v-model="queryRequest.materielName"
                  label="物料名称"
                  hide-details="auto"
                  prepend-inner-icon="search"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field
                  @keydown.enter="handleQuery"
                  clearable
                  v-model="queryRequest.materielBrand"
                  label="品牌"
                  hide-details="auto"
                  prepend-inner-icon="search"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field
                  @keydown.enter="handleQuery"
                  clearable
                  v-model="queryRequest.materielModel"
                  label="型号"
                  hide-details="auto"
                  prepend-inner-icon="search"/>
            </v-col>

          </v-row>
          <v-row>
            <v-col cols="2" class="pb-0">
              <v-text-field
                  @keydown.enter="handleQuery"
                  clearable
                  v-model="queryRequest.storageNo"
                  label="入库单号"
                  hide-details="auto"
                  prepend-inner-icon="search"/>
            </v-col>
            <v-col cols="2" class="pb-0">
              <v-text-field
                  @keydown.enter="handleQuery"
                  clearable
                  v-model="queryRequest.factSerialNo"
                  label="出厂序列号"
                  hide-details="auto"
                  prepend-inner-icon="search"/>
            </v-col>
            <v-col cols="2" class="pb-0">
              <z-source-selector
                  v-model="queryRequest.state"
                  hide-details="auto"
                  param="MATERIAL_STATUS"
                  label="状态"/>
            </v-col>
            <v-col cols="2" class="pb-0">
              <z-source-selector
                  v-model="queryRequest.businessLabel"
                  hide-details="auto"
                  param="BUSINESS_TAG"
                  label="业务标签"/>
            </v-col>
            <v-col cols="4" class="pb-0 d-flex flex-wrap align-self-end">
              <v-badge
                  :content="querySelected"
                  :value="querySelected!=0"
                  color="green"
                  overlap
              >
                <v-btn small :loading="isSearchLoading"
                       color="primary"
                       @click="handleQuery">
                  搜索
                </v-btn>
              </v-badge>

              <v-btn small color="primary"
                     class="mx-1"
                     @click="resetQuery">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>

              <v-btn small :loading="isSearchLoading"
                     color="primary"
                     class="mx-1"
                     @click="accountReport">
                一键导出
              </v-btn>

              <v-btn small :loading="isSearchLoading"
                     color="primary"
                     class="mx-1"
                     @click="importUpd">
                一键导入更新
              </v-btn>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn small
                         v-on="on"
                         class="mx-1"
                         icon
                         color="primary"
                         @click="extend">
                    <v-icon v-if="!seniorQueryFlag" large>mdi-arrow-down-drop-circle</v-icon>
                    <v-icon v-else large>mdi-arrow-up-drop-circle</v-icon>
                  </v-btn>
                </template>
                <span>高级搜索按钮</span>
              </v-tooltip>


            </v-col>
          </v-row>
          <!--------------------------    展开搜索条件     -------------------------->
          <v-expand-transition>
            <div v-show="seniorQueryFlag">
              <!--------------------------    第一行     -------------------------->

              <!--------------------------    第二行     -------------------------->
              <v-row>
                <v-col cols="2" class="py-0">
                  <v-text-field
                      @keydown.enter="handleQuery"
                      clearable
                      v-model="queryRequest.subType"
                      label="子类"
                      hide-details="auto"
                      prepend-inner-icon="search"/>
                </v-col>
                <v-col cols="3" class="d-flex justify-space-between py-0">
                  <span style="width: 110px;height: 45px" class="d-flex align-end">
                     锁定量：
                  </span>
                  <v-text-field clearable
                                @keydown.enter="handleQuery"
                                v-model="queryRequest.lockedNumMin"
                                hide-details="auto"/>
                  <span class="d-flex align-center">~</span>
                  <v-text-field clearable
                                @keydown.enter="handleQuery"
                                v-model="queryRequest.lockedNumMax"
                                hide-details="auto"/>
                </v-col>
                <v-col cols="3" class="d-flex justify-space-between py-0">
                                    <span style="width: 110px;height: 45px"
                                          class="d-flex align-end">
                                        库存量：
                                    </span>
                  <v-text-field clearable
                                @keydown.enter="handleQuery"
                                v-model="queryRequest.quantityMin"
                                hide-details="auto"/>
                  <span class="d-flex align-center">~</span>
                  <v-text-field clearable
                                @keydown.enter="handleQuery"
                                v-model="queryRequest.quantityMax"
                                hide-details="auto"/>
                </v-col>
                <v-col cols="2" class="py-0">
                  <v-text-field
                      clearable
                      @keydown.enter="handleQuery"
                      v-model="queryRequest.materielId"
                      label="物料唯一编码"
                      hide-details="auto"
                      prepend-inner-icon="search"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="2" class="py-0">
                  <v-text-field
                      clearable
                      @keydown.enter="handleQuery"
                      v-model="queryRequest.remark"
                      label="备注"
                      hide-details="auto"
                      prepend-inner-icon="search"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="py-0">
                <v-col cols="2" class="py-0">
                  <v-select
                      label="是否耗材" clearable
                      v-model="queryRequest.supplies"
                      :items="selectList"/>
                </v-col>
                <v-col cols="2" class="py-0">
                  <v-text-field
                      clearable
                      @keydown.enter="handleQuery"
                      v-model="queryRequest.accApplicableParts"
                      label="备件适用部位"
                      hide-details="auto"
                      prepend-inner-icon="search"/>
                </v-col>
                <v-col cols="2" class="py-0">
                  <v-text-field
                      clearable
                      @keydown.enter="handleQuery"
                      v-model="queryRequest.specification"
                      label="规格1"
                      hide-details="auto"
                      prepend-inner-icon="search"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="2" class="py-0">
                  <v-text-field
                      clearable
                      @keydown.enter="handleQuery"
                      v-model="queryRequest.specification2"
                      label="规格2"
                      hide-details="auto"
                      prepend-inner-icon="search"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="2" class="py-0">
                  <v-text-field
                      clearable
                      @keydown.enter="handleQuery"
                      v-model="queryRequest.specification3"
                      label="规格3"
                      hide-details="auto"
                      prepend-inner-icon="search"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="1" class="py-0">
                  <v-text-field
                      clearable
                      @keydown.enter="handleQuery"
                      v-model="queryRequest.specification4"
                      label="规格4"
                      hide-details="auto"/>
                </v-col>
                <v-col cols="1" class="py-0">
                  <v-text-field
                      clearable
                      @keydown.enter="handleQuery"
                      v-model="queryRequest.category"
                      label="品类"
                      hide-details="auto"/>
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>
        </v-form>
      </v-col>
    </v-row>

    <!------------------------------------------ 表格数据展示 ----------------------------------------->
    <v-row class="justify-center">
      <v-col cols="11">
        <v-data-table
            :headers="headers"
            :items="list"
            single-expand
            show-expand
            disable-sort
            :options.sync="options"
            :page.sync="queryRequest.pagedQueryInfo.index"
            :server-items-length="total"
            :footer-props="footerOptions">
          <template v-slot:item.opr="{ item }">
            <v-btn  small color="purple lighten-2" class="mr-1" width="83px" dark
                   @click="handleEditItem(item)">
              编辑
            </v-btn>
            <v-btn small color="primary" width="83px"
                   @click="trackReportOpen(item)">
              轨迹报告
            </v-btn>
          </template>
          <template v-slot:item.specification="{ item }">
            {{
              (item.specification ? item.specification : '') + (item.specification2 ? '-' + item.specification2 : '')
              + (item.specification3 ? '-' + item.specification3 : '') + (item.specification4 ? '-' + item.specification4 : '')
            }}
          </template>

          <template v-slot:expanded-item="{ headers,item }">
            <td :colspan="headers.length">

              <div style="padding:10px 0;">
                <span>物料唯一编码</span>：
                <span>{{ item.materielId }}</span>
              </div>
              <!--                            <div style="padding:10px 0;">-->
              <!--                              <span>采购申请单号</span>：-->
              <!--                              <span>{{ item.storageNo }}</span>-->
              <!--                            </div>-->
              <div style="padding:10px 0;">
                <span>物料产品编码</span>：
                <span>{{ item.materielProdNo }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>入库单号</span>：
                <span>{{ item.storageNo }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>入库类型</span>：
                <span>{{ item.storageTypeDesc }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>备件适用部位</span>：
                <span>{{ item.accApplicableParts }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>品类</span>：
                <span>{{ item.category }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>子类</span>：
                <span>{{ item.subType }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>需要退库</span>：
                <span>{{ item.withdrawalFlag ? '是' : '否' }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>是否耗材</span>：
                <span>{{ item.supplies ? '是' : '否' }}</span>
              </div>
              <div style="padding:10px 0;">
                <span>备注</span>：
                <span>{{ item.remark }}</span>
              </div>
              <div style="padding:10px 0;"
                   v-if="item.materialAttachedInfo && item.materialAttachedInfo.picInfos">
                <span>图片信息</span>：
                <v-row style="width: 98%;">
                  <v-col cols="4"
                         v-for="(itemImg,index) in item.materialAttachedInfo.picInfos"
                         :key="index">
                    <v-img :src="itemImg"
                           aspect-ratio="1.7"
                           contain></v-img>
                  </v-col>
                </v-row>
              </div>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!------------------------------------------ 报告展示窗口 ----------------------------------------->
    <v-dialog v-model="reportWindows" max-width="85%">
      <div style="background-color: white" class="pa-0">
        <v-row
            class="mb-3"
            no-gutters>
          <v-col cols="5" class="mt-3">
            <v-btn class="ml-1 mr-1" small color="black" @click="workSheetPrint" outlined dark>
              <v-icon>print</v-icon>
              打印
            </v-btn>
            <v-btn class="mr-1" small color="black" outlined @click="getPdf('#pdfDom','iMES物料台账轨迹报告')" dark>
              <v-icon>save_alt</v-icon>
              下载
            </v-btn>
            <v-btn class="mr-1" small color="black" outlined @click="reportWindows = !reportWindows" dark>
              <v-icon>close</v-icon>
              关闭
            </v-btn>
            <br>
          </v-col>
        </v-row>

        <section ref="print">
          <div id="pdfDom" class="work-sheet pb-7">
            <h2 style="text-align: center">iMES物料台账轨迹报告</h2>
            <v-row no-gutters>
              <v-col cols="6">
                <div style="float: left;line-height: 50px; display: table">
                  <span>报告生成时间: {{ reportData.reportDate }}</span>
                </div>
              </v-col>
              <v-col cols="6">
                <div style="float: right; display: table">
                  <img :src="base64LogoImg" style="width: 90px;height: 30px; display: table-cell"/>
                  <span
                      v-if="reportData.serviceHotline && reportData.serviceHotline.length > 0">全国服务热线：{{
                      reportData.serviceHotline
                    }}</span>
                </div>
              </v-col>
              <v-col cols="12">
                <table border="1" cellpadding="0" cellspacing="0" class="work-sheet-table">
                  <tr style="text-align: center;background-color: gainsboro">
                    <td class="text-center">物料名称</td>
                    <td class="text-center">品牌</td>
                    <td class="text-center">型号</td>
                    <td class="text-center">规格</td>
                    <td class="text-center">计量单位</td>
                    <td class="text-center">物料品类</td>
                    <td class="text-center">物料子类</td>
                    <td class="text-center">出厂序列号</td>
                    <td class="text-center">退库标志</td>
                  </tr>
                  <tr style="text-align: center">
                    <td>{{ reportData.materielName }}</td>
                    <td>{{ reportData.materielBrand }}</td>
                    <td>{{ reportData.materielModel }}</td>
                    <td>{{
                        (reportData.specification ? reportData.specification : '')
                        + (reportData.specification2 ? '-' + reportData.specification2 : '')
                        + (reportData.specification3 ? '-' + reportData.specification3 : '')
                        + (reportData.specification4 ? '-' + reportData.specification4 : '')
                      }}
                    </td>
                    <td>{{ reportData.unit }}</td>
                    <td>{{ reportData.category }}</td>
                    <td>{{ reportData.subType }}</td>
                    <td>{{ reportData.factSerialNo }}</td>
                    <td>{{ reportData.withdrawalFlag?'是':'否' }}</td>
                  </tr>
                </table>
                <br/>
              </v-col>
              <v-col cols="12">
                <table border="1" cellpadding="0" cellspacing="0" class="work-sheet-table">
                  <tr style="text-align: center;background-color: #81d4fa;cursor: pointer;">
                    <td class="text-center">时间点</td>
                    <td class="text-center">操作</td>
                    <td class="text-center">数量</td>
                    <td class="text-center">操作类型</td>
                    <td class="text-center">出/入库单号</td>
                    <td class="text-center">始发</td>
                    <td class="text-center">终点</td>
                    <td class="text-center">操作人</td>
                    <td class="text-center">申请人</td>
                    <td class="text-center">关联类型</td>
                    <td class="text-center">关联单号/工单</td>
                    <td class="text-center">状态</td>
                  </tr>
                  <tr v-for="(item,index) in reportData.trackItemList" :key="index"
                      @click="choseData(item)">
                    <td class="text-center">{{ item.timePoint }}</td>
                    <td class="text-center">{{ item.operate }}</td>
                    <td class="text-center">{{ item.count }}</td>
                    <td class="text-center">{{ item.operateType }}</td>
                    <td class="text-center">
                      <a @click="toJumpPage(item)">
                        {{ item.orderNumber }}
                      </a>
                    </td>
                    <td class="text-center">{{ item.originLocation }}</td>
                    <td class="text-center">{{ item.finishLocation }}</td>
                    <td class="text-center">{{ item.operatePerson }}</td>
                    <td class="text-center">{{ item.applyPerson }}</td>
                    <td class="text-center">{{ item.relTypeDesc }}</td>
                    <td class="text-center"> {{ item.reqSeqNo }}</td>
                    <td class="text-center">{{ item.state }}</td>
                  </tr>
                </table>
                <br/>
              </v-col>
              <v-col cols="12" v-if="reportData.entryDetailsInfoVOS">
                <h4 >交换件退库</h4>
                <table border="1" cellpadding="0" cellspacing="0" class="work-sheet-table">
                  <tr style="text-align: center;background-color:   #d8cfe0">
                    <td class="text-center">关联出库单号</td>
                    <td class="text-center">入库单号</td>
                    <td class="text-center">物料名称</td>
                    <td class="text-center">品牌</td>
                    <td class="text-center">型号</td>
                    <td class="text-center">规格</td>
                    <td class="text-center">计量单位</td>
                    <td class="text-center">物料品类</td>
                    <td class="text-center">物料子类</td>
                    <td class="text-center">出厂序列号</td>
                    <td class="text-center">退库标志</td>
                    <td class="text-center">操作</td>
                  </tr>
                  <tr v-for="(item,index) in reportData.entryDetailsInfoVOS" :key="index"
                      class="text-center"
                      :style="item.relatedOutboundNo==selectedOrderNum?'background-color: #e3ec9e':''"                    >
                    <td>{{ item.relatedOutboundNo }}</td>
                    <td>
                      <a @click="toJumpPage(item)">
                        {{ item.storageNo }}
                      </a>
                    </td>
                    <td>{{ item.materielName }}</td>
                    <td>{{ item.materielBrand }}</td>
                    <td>{{ item.materielModel }}</td>
                    <td>{{
                        (item.specification ? item.specification : '')
                        + (item.specification2 ? '-' + item.specification2 : '')
                        + (item.specification3 ? '-' + item.specification3 : '')
                        + (item.specification4 ? '-' + item.specification4 : '')
                      }}
                    </td>
                    <td>{{ item.unit }}</td>
                    <td>{{ item.category }}</td>
                    <td>{{ item.subType }}</td>
                    <td>{{ item.factSerialNo }}</td>
                    <td>{{ item.withdrawalFlag?'是':'否' }}</td>
                    <td>
                      <a @click="toQueryReport(item)">
                        查看轨迹报告
                      </a>
                      <a @click="toClearReport(item)">
                        清空
                      </a>
                    </td>
                  </tr>
                </table>
                <br/>
              </v-col>
              <v-col cols="12">
                <hr/>
              </v-col>

              <v-col cols="12" v-for="(data,index) in reportDataList" :key="index" >
                <br>
                <h4 >物料信息</h4>
                <table border="1" cellpadding="0" cellspacing="0" class="work-sheet-table">
                  <tr style="text-align: center;background-color: gainsboro">
                    <td class="text-center">物料名称</td>
                    <td class="text-center">品牌</td>
                    <td class="text-center">型号</td>
                    <td class="text-center">规格</td>
                    <td class="text-center">计量单位</td>
                    <td class="text-center">物料品类</td>
                    <td class="text-center">物料子类</td>
                    <td class="text-center">出厂序列号</td>
                  </tr>
                  <tr style="text-align: center">
                    <td>{{ data.materielName }}</td>
                    <td>{{ data.materielBrand }}</td>
                    <td>{{ data.materielModel }}</td>
                    <td>{{
                        (data.specification ? data.specification : '')
                        + (data.specification2 ? '-' + data.specification2 : '')
                        + (data.specification3 ? '-' + data.specification3 : '')
                        + (data.specification4 ? '-' + data.specification4 : '')
                      }}
                    </td>
                    <td>{{ data.unit }}</td>
                    <td>{{ data.category }}</td>
                    <td>{{ data.subType }}</td>
                    <td>{{ data.factSerialNo }}</td>
                  </tr>
                </table>
                <br/>
                <table border="1" cellpadding="0" cellspacing="0" class="work-sheet-table">
                  <tr style="text-align: center;background-color: #81d4fa">
                    <td class="text-center">时间点</td>
                    <td class="text-center">操作</td>
                    <td class="text-center">数量</td>
                    <td class="text-center">操作类型</td>
                    <td class="text-center">出/入库单号</td>
                    <td class="text-center">始发</td>
                    <td class="text-center">终点</td>
                    <td class="text-center">操作人</td>
                    <td class="text-center">申请人</td>
                    <td class="text-center">关联类型</td>
                    <td class="text-center">关联单号/工单</td>
                    <td class="text-center">状态</td>
                  </tr>
                  <tr v-for="(item,index) in data.trackItemList" :key="index"
                      @click="choseData(item)">
                    <td class="text-center">{{ item.timePoint }}</td>
                    <td class="text-center">{{ item.operate }}</td>
                    <td class="text-center">{{ item.count }}</td>
                    <td class="text-center">{{ item.operateType }}</td>
                    <td class="text-center">
                      <a @click="toJumpPage(item)">
                        {{ item.orderNumber }}
                      </a>
                    </td>
                    <td class="text-center">{{ item.originLocation }}</td>
                    <td class="text-center">{{ item.finishLocation }}</td>
                    <td class="text-center">{{ item.operatePerson }}</td>
                    <td class="text-center">{{ item.applyPerson }}</td>
                    <td class="text-center">{{ item.relTypeDesc }}</td>
                    <td class="text-center"> {{ item.reqSeqNo }}</td>
                    <td class="text-center">{{ item.state }}</td>
                  </tr>
                </table>
                <br>
                <h4 v-if="data.entryDetailsInfoVOS">交换件退库</h4>
                <table v-if="data.entryDetailsInfoVOS" border="1" cellpadding="0" cellspacing="0" class="work-sheet-table">
                  <tr style="text-align: center;background-color:  #d8cfe0">
                    <td class="text-center">关联出库单号</td>
                    <td class="text-center">入库单号</td>
                    <td class="text-center">物料名称</td>
                    <td class="text-center">品牌</td>
                    <td class="text-center">型号</td>
                    <td class="text-center">规格</td>
                    <td class="text-center">计量单位</td>
                    <td class="text-center">物料品类</td>
                    <td class="text-center">物料子类</td>
                    <td class="text-center">出厂序列号</td>
                    <td class="text-center">操作</td>
                  </tr>
                  <tr v-for="(item,index) in data.entryDetailsInfoVOS" :key="index"  class="text-center"
                      :style="item.relatedOutboundNo==selectedOrderNum?'background-color: #e3ec9e':''" >
                    <td>{{ item.relatedOutboundNo }}</td>
                    <td>
                      <a @click="toJumpPage(item)">
                        {{ item.storageNo }}
                      </a>
                    </td>
                    <td>{{ item.materielName }}</td>
                    <td>{{ item.materielBrand }}</td>
                    <td>{{ item.materielModel }}</td>
                    <td>{{
                        (item.specification ? item.specification : '')
                        + (item.specification2 ? '-' + item.specification2 : '')
                        + (item.specification3 ? '-' + item.specification3 : '')
                        + (item.specification4 ? '-' + item.specification4 : '')
                      }}
                    </td>
                    <td>{{ item.unit }}</td>
                    <td>{{ item.category }}</td>
                    <td>{{ item.subType }}</td>
                    <td>{{ item.factSerialNo }}</td>
                    <td>
                      <a @click="toQueryReport(item)">
                        查看轨迹报告
                      </a>
                      <a @click="toClearReport(item)">
                        清空
                      </a>
                    </td>
                  </tr>
                </table>
                <br>
                <hr/>
              </v-col>
            </v-row>
          </div>
        </section>

      </div>
    </v-dialog>

    <!-- update dialog start .......... -->
    <v-dialog v-model="updateDialog" persistent max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">修改台账明细</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="updateForm" v-model="updateFormValid">
            <v-container>
              <v-row>

                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[]" v-model="updateRequest.unitPrice"
                                label="单价"></v-text-field>
                </v-col>

                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 64 || '长度不得超过64',]"
                                v-model="updateRequest.storageLocation" label="库位"></v-text-field>
                </v-col>

                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[]" v-model="updateRequest.noTaxUnitPrice"
                                label="单价(不含税)"></v-text-field>
                </v-col>

                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[]" v-model="updateRequest.taxRate"
                                label="税率"></v-text-field>
                </v-col>

                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 64 || '长度不得超过64',]"
                                v-model="updateRequest.factSerialNo" label="出厂序列号"></v-text-field>
                </v-col>

                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 255 || '长度不得超过255',]"
                                v-model="updateRequest.accApplicableParts"
                                label="备件适用部位"></v-text-field>
                </v-col>

                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-switch :rules="[]" v-model="updateRequest.withdrawalFlag"
                            label="需要退库"></v-switch>
                </v-col>

                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-switch :rules="[]" v-model="updateRequest.supplies" label="是否耗材"></v-switch>
                </v-col>

                <v-col md="6" lg="6" xl="6" sm="12" xs="12">
                  <v-text-field :rules="[v => !v || v.length <= 50 || '长度不得超过50',]"
                                v-model="updateRequest.remark" label="备注"></v-text-field>
                </v-col>

              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="updateDialog = false">取消</v-btn>
          <v-btn :loading="updSubmitLoadding" :disabled="!updateFormValid" text @click="updateCommit">提交
            <!--                        -->
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- update dialog end .......... -->

    <v-dialog v-model="reportLoading"
              fullscreen
              overlay-color="white">
      <div
          style="width: 100%;height: 100%;background-color: rgba(255,255,255,0.5);display: flex;align-items: center;justify-content: center">
        <div style="text-align: center">
          <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
          >
          </v-progress-circular>
          <br/>
          <p style="margin-top: 10px; color: blue">报表生成中,请稍等...</p>
        </div>
      </div>
    </v-dialog>


    <v-dialog v-model="importUpdDialog" persistent max-width="900px">
      <v-card>
        <v-card-title>
          <span class="headline">一键导入更新</span>
        </v-card-title>
        <v-card-text>
          <v-container class="pa-0">
            <v-form ref="dialogForm">
              <v-row>
                <v-col cols="2" class="pt-6 pr-0 pb-1">
                  <span style="color: red">*</span><span> 文件上传: </span>
                </v-col>
                <v-col cols="6" class="pt-0 pl-0 pb-1">
                  <v-file-input accept=".xls,.xlsx" label="只能上传excel:xls文件，文件内容条数少于2000"
                                v-model="fileInfo"
                                :rules="[v => !!v || '一键导入更新必须上传']"
                                :loading="uploadIsLoading"
                                @change="uploadFile"></v-file-input>
                </v-col>
                <v-col cols="3" class="pt-3 pl-0">
                  <v-btn color="primary" @click="getMould">获取导入更新模板</v-btn>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6" class="pt-0 pb-0">
                  导入数据总数：<strong>{{ importInfo.total }}</strong>
                  <br>处理失败数量：<strong>{{ importInfo.fail }}</strong>
                  <br>成功数量：<strong>{{ importInfo.success }}</strong>
                  <br>处理耗时：<strong>{{ importInfo.spendTime }}</strong>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="pl-2">
                  <v-card max-width="900">
                    <v-row>
                      <v-col cols="10">
                        <v-simple-table dense>
                          <template v-slot:default>
                            <thead>
                            <tr>
                              <th class="text-center">表格序号</th>
                              <th class="text-center">物料唯一编码</th>
                              <th class="text-center">错误原因</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in failInfoList" :key="item.index">
                              <td>{{ item.index }}</td>
                              <td>{{ item.materielId }}</td>
                              <td>{{ item.error }}</td>
                            </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
          </v-container>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="closeImportUpd">
            关闭页面
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <z-confirm msg="关闭后将无法收到导入情况，后台系统正在进行的导入不会停止, 是否继续?"
               @confirm="confirmClose"
               v-model="isCloseImportUpd"></z-confirm>


  </v-container>
</template>

<script>

import reportDownLoad from "@/utils/reportDownLoad"
import {dataChangedCountMixin,dataCatchMixin} from "@/mixin"
import {accountReport, importUpd, queryRequest, trackReport, update,materialUpdTemplate} from "@/api/entryDetailsInfo";
import {getBase64} from '@/utils/urlToData'
import {mapGetters} from "vuex"

export default {
  name: "AccountManagement",
  computed: {
    ...mapGetters([
      "wmsMngFlag"
    ]),
  },
  data: () => ({
    footerOptions: {
      itemsPerPageOptions: [10, 50, 100, 200]
    },
    nowTime: "",
    seniorQueryFlag: false,
    isSearchLoading: false,
    reportWindows: false,
    updateDialog: false,
    updateFormValid: false,
    updSubmitLoadding: false,
    reportLoading: false,
    editStorageLocationWindows: false,
    editLocationFormValid: false,
    list: [],
    total: 0,
    selectList: [{
      value: true,
      text: '是'
    }, {
      value: false,
      text: '否'
    }],
    reportData: {
      "category": "",
      "compName": "",
      "companyId": "",
      "factSerialNo": "",
      "logoPath": "",
      "materielBrand": "",
      "materielModel": "",
      "materielName": "",
      "materielProdNo": "",
      "reportDate": "",
      "serviceHotline": "",
      "specification": "",
      "specification2": "",
      "specification3": "",
      "specification4": "",
      "subType": "",
      "trackItemList": [
        {
          applyPerson: "",
          "count": 0,
          "finishLocation": "",
          "operate": "",
          "operatePerson": "",
          "operateType": "",
          "originLocation": "",
          "reqSeqNo": "",
          "state": "",
          "timePoint": "",
          orderNumber: "",
        }
      ],
      entryDetailsInfoVOS: [{
      }],
      "unit": "",
      "stateDesc": "",
    },
    reportDataList: [],
    reportIds:[],
    selectedOrderNum:'',
    options: {},
    headers: [
      {text: '仓库', value: 'warehouseName', align: 'center',},
      {text: '库位', value: 'storageLocation', align: 'center',},
      {text: '采购申请单号', value: 'purchaseApplyNo', align: 'center',},
      {text: '物料名称', value: 'materielName', align: 'center',},
      {text: '品牌', value: 'materielBrand', align: 'center',},
      {text: '型号', value: 'materielModel', align: 'center',},
      {text: '规格', value: 'specification', align: 'center',},
      {text: '单价', value: 'unitPrice', align: 'center',},
      {text: '单价(不含税)', value: 'noTaxUnitPrice', align: 'center'},
      {text: '税率', value: 'taxRate', align: 'center'},
      {text: '出厂序列号', value: 'factSerialNo', align: 'center',},
      {text: '状态', value: 'stateDesc', align: 'center',},
      {text: '锁定量', value: 'lockedNum', align: 'center',},
      {text: '库存量', value: 'quantity', align: 'center',},
      {text: '计量单位', value: 'unit', align: 'center',},
      {text: '业务标签', value: 'businessLabelDesc', align: 'center',},
      // {text: '附件资料', value: 'attachedInfo'},
      {text: '操作', value: 'opr', align: 'center',},
      {text: ' ', value: 'data-table-expand', align: 'center',},
    ],
    trackReportRequest: {
      id: ""
    },
    storageLocationRequest: {
      id: "",
      storageLocation: ""
    },
    queryRequest: {
      "id": "",
      "pagedQueryInfo": {
        "index": 1,
        "pageSize": 10
      },
      "materielId": "",
      "companyId": "",
      "warehouseId": [],
      "warehouseName": "",
      "storageLocation": "",
      "materielProdNo": "",
      "materielName": "",
      "materielBrand": "",
      "materielModel": "",
      "specification": "",
      "specification2": "",
      "specification3": "",
      "specification4": "",
      "accApplicableParts": "",
      "factSerialNo": "",
      "category": "",
      "subType": "",
      "withdrawalFlag": null,
      "supplies": null,
      "state": "",
      "lockedNum": "",
      "quantity": "",
      "unit": "",
      "businessLabel": "",
      "guarEndDate": "",
      "storageNo": "",
      "attachedInfo": "",
      "remark": "",
      "createDateTime": [],
      "eqpProdId": "",
      "lockedNumMin": "",
      "lockedNumMax": "",
      "quantityMin": "",
      "quantityMax": ""
    },
    updateRequest: {
      id: null, //ID
      materielId: null, //物料唯一编码
      companyId: null, //公司编号
      warehouseId: null, //仓库编号
      warehouseName: null, //仓库名称
      storageLocation: null, //库位
      materielProdNo: null, //物料产品编码
      materielName: null, //物料名称
      materielBrand: null, //物料品牌
      materielModel: null, //物料型号
      specification: null, //规格1
      specification2: null, //规格2
      specification3: null, //规格3
      specification4: null, //规格4
      accApplicableParts: null, //备件适用部位
      factSerialNo: null, //出厂序列号
      category: null, //品类
      subType: null, //子类
      withdrawalFlag: null, //需要退库
      supplies: null, //是否耗材
      state: null, //状态
      lockedNum: null, //锁定量
      quantity: null, //库存量
      unit: null, //单位
      unitPrice: null, //单价
      noTaxUnitPrice: null, //单价
      taxRate: null, //单价
      businessLabel: null, //业务标签
      guarEndDate: null, //质保到期日
      storageNo: null, //入库单号
      attachedInfo: null, //附件资料
      remark: null, //备注
      lstupdDateTime: null, //更新时间
    },
    tableUpdateOriginalItem: {},
    base64LogoImg: "",

    //一键导入更新
    importUpdDialog: false,
    fileInfo: null,
    uploadIsLoading: false,
    importInfo: {},
    failInfoList: [],
    isCloseImportUpd: false,

  }),
  mixins: [dataChangedCountMixin,dataCatchMixin],
  watch: {
    options: {
      handler(val) {
        if (val.itemsPerPage == -1) {
          this.queryRequest.pagedQueryInfo.index = 1
          this.queryRequest.pagedQueryInfo.pageSize = 999999
        } else if (!!val.page && !!val.itemsPerPage) {
          this.queryRequest.pagedQueryInfo.index = val.page
          this.queryRequest.pagedQueryInfo.pageSize = val.itemsPerPage
        }
        // this.queryRequest.sortInfo.sortBy = val.sortBy
        // this.queryRequest.sortInfo.sortDesc = val.sortDesc
        this.queryPageData()
      }
    }
  },
  methods: {
    //获取模板
    getMould() {
      this.isShowLoading = true;
      materialUpdTemplate({}).then(res => {
        this.isShowLoading = false;
        reportDownLoad(res);
      }).catch(() => {
        this.isShowLoading = false;
      });
    },
    resetQuery() {
      Object.assign(this.$data, this.$options.data());
      this.updateFormValid = true;
    },
    extend() {
      this.seniorQueryFlag = !this.seniorQueryFlag;
    },
    //获取当前时间
    timeFormat(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
      let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
      let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
      let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
      let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
      this.nowTime = year + "年" + month + "月" + date + "日" + " " + hh + ":" + mm + ':' + ss;
    },

    //物料
    queryPageData() {
      this.loading = true
      queryRequest(this.queryRequest).then(res => {
        this.list = res.list
        this.total = res.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery() {
      this.queryRequest.pagedQueryInfo.index = 1
      this.queryPageData();
    },
    accountReport() {
      this.reportLoading = true;
      console.log(this.queryRequest)
      accountReport(this.queryRequest).then(res => {
        this.$router.push({
          path: '/export-report-queue?id=' + res
        });
        this.reportLoading = false;
      }).catch(err => {
        this.reportLoading = false;
      });
    },
    //轨迹报告打开
    trackReportOpen(data) {
      this.timeFormat(Date())
      this.trackReportRequest.id = data.id
      this.reportIds= [];
      this.reportDataList = [];
      trackReport(this.trackReportRequest).then(res => {
        this.reportData = res
        this.reportData.stateDesc = data.stateDesc
        this.reportWindows = !this.reportWindows
        getBase64(this.reportData.logoPath, data => {
          this.base64LogoImg = data
        })
      }).catch(() => {
        this.reportWindows = !this.reportWindows
      })
    },
    //编辑库位打开
    handleEditItem(item) {
      this.updateRequest = JSON.parse(JSON.stringify(item));
      this.tableUpdateOriginalItem = JSON.parse(JSON.stringify(item));
      this.updateDialog = true;
    },
    updateCommit() {
      this.updSubmitLoadding = true;
      // // 比较修改前数据
      // let updateObject = this.$compChangedToNewObject(
      //     this.tableUpdateOriginalItem,
      //     this.updateRequest
      // );
      // 设定修改对象主键/ID
      // updateObject["id"] = this.tableUpdateOriginalItem["id"];
      update(this.updateRequest)
          .then(() => {
            this.updSubmitLoadding = false;
            this.updateDialog = false;
            this.queryPageData();
          })
          .catch((err) => {
            this.updSubmitLoadding = false;
            console.error(err);
          });
    },


    //一键导入更新
    importUpd() {
      this.importUpdDialog = true;
      this.fileInfo = null;
      this.importInfo = {};
      this.failInfoList = [];
    },

    // 上传文件方法
    uploadFile() {
      const formData = new window.FormData();
      //新增资产管理部门和所属部门字段
      if (!this.fileInfo) {
        return;
      } else {
        this.uploadIsLoading = true;
        formData.append('file', this.fileInfo);
        importUpd(formData).then(res => {
          this.uploadIsLoading = false;
          this.importInfo = res
          this.failInfoList = this.importInfo.failInfoList
          if (this.failInfoList.length > 0) {
            this.$refs.notify.show("文件内容有误", {timeout: 1000, color: 'red'});
          } else {
            this.$refs.notify.show("文件上传成功", {timeout: 1000, color: 'success'});
          }
        }).catch(() => {
          this.uploadIsLoading = false;
        });
      }
    },

    //关闭导入更新窗口
    closeImportUpd() {
      if (this.uploadIsLoading) {
        this.isCloseImportUpd = true;
      } else {
        this.importUpdDialog = false;
      }
    },

    confirmClose() {
      this.isCloseImportUpd = false;
      this.importUpdDialog = false;
    },

    workSheetPrint() {
      this.$print(this.$refs.print) // 使用
    },

    //跳转页面
    toJumpPage(item) {
      if (item.orderNumber) {
        let xtbl;
        if (item.operate === '出库'|| item.operate === '出库红冲') {
          xtbl = this.$router.resolve({path: '/warehouse-out-record?outboundNum=' + item.orderNumber});
          this.$store.dispatch('setCurretTitle', '出库记录');
        } else if (item.operate === '入库'|| item.operate === '入库红冲') {
          xtbl = this.$router.resolve({path: '/warehousing-management?storageNo=' + item.orderNumber});
          this.$store.dispatch('setCurretTitle', '入库管理');
        }
        window.open(xtbl.href, '_blank');
      }
    },

    //查看轨迹报告
    toQueryReport(item) {
      if (this.reportIds.indexOf(item.id) < 0) {
        let req = {
          id: item.id,
        }
        this.reportIds.push(item.id);
        trackReport(req).then(res => {
          this.reportDataList.push(res);
        }).catch(err => {
          console.error("toQueryReport error", err)
        })
      }
    },
    //清空轨迹报告
    toClearReport(item) {
      let index = this.reportIds.indexOf(item.id);
      if (index >= 0) {
        this.reportIds = this.reportIds.slice(0,index);
        this.reportDataList = this.reportDataList.slice(0,index);
      }
    },
    //选中轨迹
    choseData(item){
      this.selectedOrderNum =  item.orderNumber
    }

  },

  created() {
    const warehouseId = this.$route.query.warehouseId;
    if (warehouseId) {
      this.queryRequest.warehouseId = warehouseId
    }
    const materielProdNo = this.$route.query.materielProdNo;
    if (materielProdNo) {
      this.queryRequest.materielProdNo = materielProdNo
    }
    const factSerialNo = this.$route.query.factSerialNo;
    if (factSerialNo) {
      this.queryRequest.factSerialNo = factSerialNo
    }
    const storageNo = this.$route.query.storageNo;
    if (storageNo) {
      this.queryRequest.storageNo = storageNo
    }
    const state = this.$route.query.state;
    if (state) {
      if (state === '07') {
        this.queryRequest.lockedNumMin = 1
      } else {
        this.queryRequest.state = state
      }
    }
    this.queryPageData()
  },
  mounted() {
  },
}
</script>

<style scoped>
.work-sheet {
  padding: 0px 20px;
}

.work-sheet-table {
  text-align: left;
  width: 100%;
}

.work-sheet-table tr td {
  padding: 3px;
  padding-left: 10px;
}

</style>
